import { Button } from "@/components/ui/button";
import { lovable } from "@/integrations/lovable/index";
import { useToast } from "@/hooks/use-toast";

interface MicrosoftSignInButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export function MicrosoftSignInButton({ onClick, disabled, className = "", children }: MicrosoftSignInButtonProps) {
  const { toast } = useToast();

  const defaultHandler = async () => {
    const { error } = await lovable.auth.signInWithOAuth("microsoft", {
      redirect_uri: window.location.origin,
    });
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      className={`w-full gap-2 text-xs ${className}`}
      disabled={disabled}
      onClick={onClick || defaultHandler}
    >
      <svg className="h-4 w-4" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="10" height="10" fill="#F25022" />
        <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
        <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
        <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
      </svg>
      {children || "Continue with Microsoft"}
    </Button>
  );
}
